module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "content-praise",
    attrs: {
      "id": "calibre_toc_3"
    }
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_vm._v("Praise for Irene O’Garden’s Work")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "charoverride1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }, [_vm._v("“For many years now, the poet, playwright, and memoirist Irene O’Garden has been a hero to me. I think of her as a walking, writing, beam of light. It is my hope that…numberless others will come to know her gifts and, most of all, her captivating talent for wonder an"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("d")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("marvel.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quoteauthor"
  }, [_vm._v("—Elizabeth Gilbert, author of "), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("Eat, Pray, Love ")]), _vm._v("and"), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak1"
  }, [_vm._v("Big")]), _c('span', {
    staticClass: "nobreak1"
  }), _c('span', {
    staticClass: "nobreak1"
  }, [_vm._v("Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }, [_vm._v("“Bewitching…astounding…heart"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("breaking.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quoteauthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("New ")]), _c('span', {
    staticClass: "nobreak1"
  }, [_vm._v("York")]), _c('span', {
    staticClass: "nobreak1"
  }), _c('span', {
    staticClass: "nobreak1"
  }, [_vm._v("Times")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }, [_vm._v("“An immersion into what we relish, how we live, a kind of shining beacon that doesn’t shy away from the tough stuff…. Highly"), _c('span', {
    staticClass: "nobreak"
  }), _vm._v("rec"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("ommended.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quoteauthor"
  }, [_vm._v("—Janet Pierson, Producer, SXSW Film Conference an"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("d")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("Festival")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quote"
  }, [_vm._v("“In a far-ranging and elegant suite of poems, Irene O’Garden balances a galaxy of incommensurates on the fulcrum of a disciplined intelligence. ‘I am a blueprint of a holy universe’ seesaws against ‘I feel like a set of china’—the former in a Herbert-like sacred meditation, the latter in a narrative about being chased by a bull. Her technique suggests influences ranging from Donne to Bishop, from Frost to Moore. Soulful and rewarding, these poems remind us that ‘We’re not made of matter but of mat"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("tering.’ ”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quoteauthor"
  }, [_vm._v("—T.R. Hummer, whose poems appear in "), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("The New Yorker")]), _vm._v(", "), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("Best of American Poetry")]), _vm._v(", "), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("Harper’s")]), _vm._v(", "), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("Atlantic Monthly")]), _vm._v(", "), _c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("Paris Review")]), _vm._v(", and twelve volumes "), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("of his")]), _c('span', {
    staticClass: "nobreak"
  }), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("own")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quoteauthor"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("“The poems in Irene O’Garden’s new book,")]), _c('span', {
    staticClass: "charoverride2"
  }, [_vm._v(" Fulcrum")]), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v(", illustrate the importance and vitality of poetry in our daily lives. Beautiful imagery, powerful emotions, simplicity, complexity and thought-provoking subjects—all drawn from relatable life experiences—make reading her work a journey of discovery and reflection by focusing on what it means to live a life of passion and wonderment. Like the author herself, the poems in these pages inspire and draw one in. This is a beautiful")]), _c('span', {
    staticClass: "nobreak2"
  }), _c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("co")]), _c('span', {
    staticClass: "nobreak2"
  }, [_vm._v("llection.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_quoteauthor"
  }, [_vm._v("—Professor Jane Kinney Denning of Pace University, President of Women’s National Book A"), _c('span', {
    staticClass: "nobreak"
  }, [_vm._v("ssociation")])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_6"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-452d1dee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/GladtoBeHuman_split_002.vue
// module id = 66
// module chunks = 0